export default __webpack_public_path__ + "assets/icons/contact-phone.2a128b63.svg";